import React, { useCallback, useState } from 'react'

import { v4 as uniqid } from 'uuid'

import PageWrapper from '@Layout/PageWrapper'
import Layout      from '@Layout/BackOffice'

import PrivateSaleForm from '@/Form/PrivateSaleForm'

import getFormStatus from '@/Form/Functions/getFormStatus'

import LoadPrivateSale from '@fetcher/LoadPrivateSale'

import FormsStore from '@Store/Forms'

const FORM_NAME = 'PrivateSale';

export default PageWrapper(function EditPrivateSale (props)
{
	const [loading, setLoading] = useState(true);
	const [status, setStatus] = useState({ });
	const [fetch_id, setFetchId] = useState('0');

	const form_slug = FormsStore.useState(s => s[FORM_NAME]?.slug);

	const slug = getSlug();

	const onSuccess = useCallback(function (private_sale)
	{
		FormsStore.update(function (store)
		{
			store[FORM_NAME] =
			{
				max_people: stringifyNum(private_sale.max_people),

				'opening[date]': private_sale.opening.date,
				'opening[h]': private_sale.opening.h,
				'opening[m]': private_sale.opening.m,

				id: private_sale.id,
				status: private_sale.status,
				slug: private_sale.slug,
				title: private_sale.title,

				excluded_ECs: private_sale.excluded_ECs || [],
				address: private_sale.address,
				payment_infos: private_sale.payment_infos,
				countdown_days: stringifyNum(private_sale.countdown_days),

				is__started: private_sale.is__started,

				dates: private_sale.dates.map(function (row)
				{
					const data =
					{
						id: row.id,
						date: row.date,

						start:
						{
							h: stringifyNum(row.start.h),
							m: stringifyNum(row.start.m)
						},

						end:
						{
							h: stringifyNum(row.end.h),
							m: stringifyNum(row.end.m)
						}
					};

					return data;
				})
			};
		});

		setLoading(false);
	},
	[]);

	const onError = useCallback(function (status)
	{
		setStatus(status.info ? { info: status.info } : status);
		setLoading(false);
	},
	[]);

	const handleUpdate = useCallback(function (e)
	{
		setFetchId(uniqid());
	},
	[]);

	return (
		<Layout page_title="Vente privée" history={ props.history }>

			<div className="page-content">

				{
					!slug || form_slug === slug ?
					(
						<PrivateSaleForm type={ slug ? 'update' : 'create' }
							onUpdate={ handleUpdate }
						/>
					)
					: undefined
				}

				{ getFormStatus(status) }

			</div>

			{
				slug ?
				(
					<LoadPrivateSale slug={ slug }
						onSuccess={ onSuccess }
						onError={ onError }
						admin
						id={ fetch_id }
					/>
				)
				: undefined
			}

		</Layout>
	);
});

function getSlug ()
{
	if (document.location.pathname.endsWith('/nouvelle')) return '';

	let str = document.location.pathname;

	if (str.endsWith('/')) str = str.slice(0, -1);

	return str.slice(str.lastIndexOf('/')+1);
}

function stringifyNum (value)
{
	return value === 0
	? '0'
	: String(value || '');
}